import React, { useContext, useEffect } from "react";
import * as FaIcons from "react-icons/fa";

import UserContext from "../../context/users/userContext";

const SearchUser = ({ text, handleOnChange, setSelectedUser }) => {
  const userContext = useContext(UserContext);
  const { sqlUserResults, closePersonDatabaseConnection } = userContext;

  useEffect(() => {
    return () => {
      closePersonDatabaseConnection();
    };
  }, []);

  return (
    <div className="search-user-component">
      <div className="form">
        <h3 className="text-center user-title">Search For User</h3>
        <input type="search" value={text} onChange={(e) => handleOnChange(e)} />
      </div>
      <div className="search-results">
        {sqlUserResults.length > 0 ? (
          <ul>
            {sqlUserResults.map((item) => {
              const {
                FirstName,
                LastName,
                EmailAddress,
                Title,
                Company,
                Office,
              } = item;
              return (
                <li onClick={() => setSelectedUser(item)}>
                  <div className="top">
                    <FaIcons.FaUserCircle className="top-icon" />
                    <p>{`${FirstName} ${LastName}`}</p>
                  </div>
                  <div className="middle">
                    <p>
                      <span>Email: </span> {EmailAddress}
                    </p>
                    <p>
                      <span>Title: </span> {Title}
                    </p>
                    <p>
                      <span>Company: </span> {Company}
                    </p>
                    <p>
                      <span>Office: </span> {Office}
                    </p>
                  </div>
                </li>
              );
            })}
          </ul>
        ) : null}
      </div>
    </div>
  );
};

export default SearchUser;
